import * as React from 'react'
import Iframe, { FrameContextConsumer } from 'react-frame-component'
import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'

type Props = {
  onChangeHeight?: any
}

export const IframeWrapper: React.FC<Props> = ({
  // @ts-ignore
  children,
  onChangeHeight
}) => {
  const ref = React.useRef()
  const [height, setHeight] = React.useState(0)

  const onLoad = () => {
    // @ts-ignore
    // console.log('onload', ref.current.contentWindow.document.body.scrollHeight)
    if (ref && ref.current) {
      // @ts-ignore
      const newHeight = ref.current.contentWindow.document.body.scrollHeight
      setHeight(newHeight)
      if (onChangeHeight) {
        onChangeHeight(newHeight)
      }
    }
  }

  return (
    <Iframe
      height={height}
      // @ts-ignore
      ref={ref}
      contentDidMount={onLoad}
      contentDidUpdate={onLoad}
      style={{
        padding: 0,
        margin: 0,
        border: 0,
        overflow: 'hidden',
        width: '100%'
      }}
    >
      <FrameContextConsumer>
        {(frameContext: any) => {
          const cache = createCache({
            container: frameContext.document.head,
            key: 'iframe-wrapper'
          })
          return <CacheProvider value={cache}>{children}</CacheProvider>
        }}
      </FrameContextConsumer>
    </Iframe>
  )
}
export default IframeWrapper
